module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.32400f4e.eot";